"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaEscola = exports.yupEscola = void 0;
const yup = __importStar(require("yup"));
const enums_1 = require("../enums");
exports.yupEscola = yup.object({
    codigo: yup.string().default('').label(''),
    nome: yup.string().max(81, 'Máximo de 81 caracteres.').default('').required().label('Nome'),
    nomeReduz: yup.string().max(30, 'Máximo de 30 caracteres.').default('').label('Nome Abreviado'),
    nomeTela: yup.string().max(80, 'Máximo de 80 caracteres.').default('').label('Nome Tela'),
    endereco: yup.string().max(40, 'Máximo de 40 caracteres.').default('').required().label('Endereço'),
    bairro: yup.string().max(15, 'Máximo de 15 caracteres.').default('').required().label('Bairro'),
    cidade: yup.string().max(40, 'Máximo de 40 caracteres.').default('').required().label('Cidade'),
    estado: yup.string().default('').required().label('Estado'),
    cep: yup.string().default('').required().label('CEP'),
    //Caixa
    //prefixo
    fone: yup.string().max(15, 'Máximo de 15 caracteres.').default('').required().label('Fone'),
    //fax
    mantenedo: yup.string().max(100, 'Máximo de 100 caracteres.').default('').label('Mantenedora'),
    cgc: yup.string().max(18, 'Máximo de 18 caracteres.').default('').required().label('CNPJ'),
    titulo: yup.string().max(80, 'Máximo de 80 caracteres.').default('').label('Título').default(''),
    //obssecret
    //diretorA
    //obsdiretor
    bimestre: yup.number().default(1).label('Bimestre'),
    //ano
    dias: yup.number().default(5).required().label('Dia de Vencimento padrão das Mensalidades'),
    parcelas: yup.string().default('12').required().label('Número de parcelas no ano'),
    //dias2
    atraso: yup.number().required().default(2).label('Multa Cobrada no atraso'),
    mora: yup.number().required().default(1).label('Juros cobrados no atraso'),
    geraparc: yup.boolean().required().default(false).label('Gerar Mensalidades na Matrícula'),
    //usacarne
    //proccontab
    //formcarne
    //janCheia
    //copIrmao
    //ordemTurm
    //impLogoBol
    //linhacarne
    //hora
    //dataav
    //anivDiret
    //secretaria
    //nomeapm
    //nomeEst
    //biblioteca
    //tipocobran
    //pgcobdt
    //viasLaser
    //impvencmat: yup.boolean().required().default(true).label('Imprime a data de vencimento da matrícula'),
    impdescdia: yup.boolean().required().default(true).label('Opção de desconto para pagamento em dia'),
    //cedtmplib
    //cednnum
    //espCarne
    //modoImp
    //pgcobcd
    //codbanco
    //taxadesc
    //vrDesc
    //logoescola
    //logoestado
    //pgcobultdt
    //implogodoc
    //avaliacao
    secNome: yup.string().max(40, 'Máximo de 40 caracteres.').default('').label('Nome do(a) Secretário(a)'),
    secRg: yup.string().max(26, 'Máximo de 26 caracteres.').default('').label('RG do(a) Secretário(a)'),
    secAto: yup.string().max(30, 'Máximo de 30 caracteres.').default('').label('Ato  do(a) Secretário(a)'),
    secTitulo: yup.string().max(50, 'Máximo de 50 caracteres.').default('').label('Desig. do(a) Secretário(a)'),
    secDoe: yup.string().max(10, 'Máximo de 10 caracteres.').default('').label('DOE do(a) Secretário(a)'),
    dirNome: yup.string().max(40, 'Máximo de 40 caracteres.').default('').label('Nome do(a) Diretor(a)'),
    dirRg: yup.string().max(26, 'Máximo de 26 caracteres.').default('').label('RG do(a) Diretor(a)'),
    dirAto: yup.string().max(30, 'Máximo de 30 caracteres.').default('').label('Ato do(a) Diretor(a)'),
    dirTitulo: yup.string().max(50, 'Máximo de 50 caracteres.').default('').label('Desig. do(a) Diretor(a)'),
    dirDoe: yup.string().max(10, 'Máximo de 10 caracteres.').default('').label('DOE do(a) Diretor(a)'),
    iee: yup.string().max(25, 'Máximo de 25 caracteres.').default('').label('IEE'),
    nre: yup.string().max(25, 'Máximo de 25 caracteres.').default('').label('NRE'),
    //autoriza
    //recEstab
    //recDoe
    //recCurso
    //recCurso2
    //bloqFIni
    //bloqFFim
    //bolMens
    //bolMens1
    //recMens
    //codesccob
    //fechamat
    //formaCalc
    carJuros: yup.number().integer().nullable().default(null).label('Dias de carência p/ cobrar multa / juros'),
    carDUtil: yup.boolean().nullable().default(false).label('Dia útil'),
    //leiH1c
    //leiH2c
    impBolAs: yup.boolean().required().default(false).label('Assinatura do Responsável'),
    impBolAt: yup.boolean().required().default(false).label('Assinatura do(a) Secretário(a)'),
    impBolDi: yup.boolean().required().default(true).label('Assinatura do(a) Diretor(a)'),
    impBolCo: yup.boolean().required().default(false).label('Assinatura da Coordenação'),
    impBolPr: yup.boolean().required().default(false).label('Assinatura do(a) Professor(a)'),
    impBolOc: yup.boolean().required().default(true).label('Não imprimir ocorrências no boletim'),
    //impdesccar
    fcalcjuros: yup
        .mixed()
        .oneOf(Object.values(enums_1.ETipoCalcJuros))
        .notRequired()
        .default(enums_1.ETipoCalcJuros['0) Cálculo de Juros Diário'])
        .label('Forma de Cálculo dos Juros'),
    //outrosRec
    //linCodbar
    //espCodbar
    //impressora
    //diautil
    //mantervenc
    //feriados
    nomeestado: yup.string().max(70, 'Máximo de 70 caracteres.').default('').label('Nome na Documentação do Estado'),
    orgao: yup.string().max(100, 'Máximo de 100 caracteres.').default('').label('Orgão Responsável'),
    agrupVenc: yup.boolean().required().default(true).label('Agrupar parcelas por Vencimento'),
    agrupResp: yup.boolean().required().default(false).label('Agrupar parcelas por responsável'),
    //cobPAlun
    //cobPCod
    //lembrabaix
    emailSec: yup.string().max(60, 'Máximo de 60 caracteres.').default('').label('E-mail da Secretaria'),
    emailTes: yup.string().max(60, 'Máximo de 60 caracteres.').default('').label('E-mail da Tesouraria'),
    emailAdm: yup.string().max(60, 'Máximo de 60 caracteres.').default('').label('E-mail da Administração'),
    site: yup.string().max(60, 'Máximo de 60 caracteres.').default('').label('Endereço do Site'),
    //matTipop
    //juroAuto
    //baixabanco
    //dtmats
    //histcarga1
    //caixatrans
    //histseqant
    //dataMed
    //fechaauto
    //transdeb
    //manterprod
    //codOnibus
    //cadindica
    //lanCheque
    agrupTp: yup.string().default('').label('Tipo de agrupamento'),
    cmc: yup.string().default('').label('C.M.C.'),
    profWeb: yup.boolean().required().default(true).label('Utiliza módulo Professor.'),
    onlineInt: yup
        .string()
        .max(160, 'Máximo de 160 caracteres.')
        .default('')
        .label('Endereço do online na rede interna.'),
    onlineExt: yup.string().max(160, 'Máximo de 160 caracteres.').default('').label('Endereço dos módulos online'),
    siteLib: yup.boolean().required().default(true).label('Liberar acesso nos módulos'),
    //notasLib
    //provasLib
    libchamada: yup.boolean().required().default(true).label('Utilizar chamada pelo módulo Professor.'),
    chamsgrade: yup.boolean().required().default(false).label('Utiliza chamada sem grade determinada.'),
    multigrade: yup.boolean().required().default(true).label('Utiliza multiplas grades'),
    //digiLib //Liberar acesso aos professores
    //digiIni
    //digiFim
    //bimSite
    anoSite: yup.string().default('').required().label('Ano Letivo atual'),
    //site2viatu
    //sitemdesc
    //siterecibo
    anoMatric: yup.string().default('').label('Ano da rematrícula'),
    //bloqDebit
    //digiAulad
    //digiAulap
    //confmatbx
    //digEfIni
    //digEfFim
    som1desc: yup
        .boolean()
        .nullable()
        .default(false)
        .label('Se o aluno possui bolsa, não dar desc. p/ pgto em dia da Turma'),
    //nlembrdesc
    assinatsec: yup.string().max(50, 'Máximo de 50 caracteres.').default('').label('Assinatura do(a) secretário(a)'),
    assinatdir: yup.string().max(50, 'Máximo de 50 caracteres.').default('').label('Assinatura do(a) diretor(a)'),
    //dataPub
    rematric: yup.boolean().required().default(false).label('Habilitar rematrícula'),
    etapas: yup.number().default(4).label('Número de etapas'),
    //horaIPub
    //horaFPub
    //percPub
    verSge: yup.string().max(12, 'Máximo de 12 caracteres.').default('').label('Versão do SGE2').notRequired().nullable(),
    verExp: yup
        .string()
        .max(12, 'Máximo de 12 caracteres.')
        .default('')
        .label('Versão do Exportador')
        .notRequired()
        .nullable(),
    //bloqmatdev
    //alunoWeb
    //profDesk
    boletoweb: yup.boolean().required().default(true).label('Habilita impressão de boletos.'),
    //manteregis
});
exports.schemaEscola = exports.yupEscola.shape({});
